const MIN_WS_TIMEOUT = 1000;
const WS_TIMEOUT = 30000;

export {
  MIN_WS_TIMEOUT,
  WS_TIMEOUT,
};
